<h5
  class="h5"
  mat-dialog-title>
  {{ data.title }}
</h5>

<mat-dialog-content class="dialog-content">
  <section class="form">
    <div class="dcontents">
      <mat-form-field>
        <mat-label>First name</mat-label>
        <input
          matInput
          [formControl]="form.controls.first_name" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Last name</mat-label>
        <input
          matInput
          [formControl]="form.controls.last_name" />
      </mat-form-field>
    </div>

    <div class="dcontents">
      <mat-form-field>
        <mat-label>Email</mat-label>
        <input
          matInput
          [formControl]="form.controls.email" />
      </mat-form-field>
    </div>

    <mat-form-field>
      <mat-label>Role</mat-label>
      <mat-select [formControl]="form.controls.role">
        @for (role of usersRole(); track role) {
          <mat-option [value]="role.name">
            {{ role.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (showSqlQueryAccess()) {
      <mat-checkbox
        color="primary"
        [formControl]="form.controls.sqlQueryAccess"
        matTooltip="Allows read-only SQL queries to test company databases (qa-psql). Super user has access only to their own companies.">
        SQL query access
      </mat-checkbox>
    }
  </section>

  @if (!company()?.id) {
    <section class="companies app-mt-s">
      <app-search-field
        [control]="searchControl"
        [placeholder]="'Search companies...'" />
      <mat-checkbox
        [color]="'primary'"
        [checked]="selection.hasValue() && isAllSelected()"
        [indeterminate]="selection.hasValue() && !isAllSelected()"
        (change)="toggleAllRows()"
        [disabled]="isDisabledSelectCompany()"
        [labelPosition]="'before'">
        Select all companies ({{ companiesList().length }})
      </mat-checkbox>
      <section class="form">
        @for (category of companiesList(); track category.id) {
          <mat-checkbox
            [color]="'primary'"
            [disabled]="isDisabledSelectCompany()"
            (change)="selection.toggle(category)"
            [checked]="selection.isSelected(category)"
            [labelPosition]="'before'">
            {{ category.name }}
          </mat-checkbox>
        }
      </section>
    </section>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <app-button
    variant="stroked"
    color="neutral"
    mat-dialog-close>
    Cancel
  </app-button>
  <app-button
    [disabled]="(form.statusChanges | async) !== 'VALID'"
    mat-dialog-close
    (click)="save()">
    Confrim
  </app-button>
</mat-dialog-actions>
